// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.smallIcon{
    width: 21px;
    height: 21px;
    font-size: 21px;
}
.smallButton {
  width: 30px;
  height: 30px;
  --mdc-icon-button-state-layer-size: 30px;
  padding: 0px;
}`, "",{"version":3,"sources":["webpack://./src/app/candidate-email-button/candidate-email-button.component.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,YAAY;IACZ,eAAe;AACnB;AACA;EACE,WAAW;EACX,YAAY;EACZ,wCAAwC;EACxC,YAAY;AACd","sourcesContent":[".smallIcon{\n    width: 21px;\n    height: 21px;\n    font-size: 21px;\n}\n.smallButton {\n  width: 30px;\n  height: 30px;\n  --mdc-icon-button-state-layer-size: 30px;\n  padding: 0px;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
